export default __webpack_public_path__ + "static/media/bannerBig3.ebf9b6f3.png";